module.exports = __webpack_public_path__ + "img/boco_bobocoin.gm.da12fed.png";